/**
 * Mercado "atual" do ponto de vista da UI: 'spot' ou 'futures'.
 * É a lente de MERCADO (acima do ambiente prod/test): separa os dois mundos
 * (spot vs futuros) porque operar futuros tem alavancagem/liquidação ≠ spot.
 *
 * - currentMarket: o mercado em que o usuário está navegando agora.
 * - defaultMarket: preferência opcional p/ entrar DIRETO num mercado após o login
 *   (checkbox nos cards). Se vazio, mostra a tela de seleção de cards primeiro.
 *
 * Persiste em localStorage. Ver project_futures_short_mapping (design dos 2 cards).
 */

import { getPathHomePage } from './HomePageUtils';

const KEY = 'currentMarket';
const DEFAULT_KEY = 'defaultMarket';

export const MARKET_SPOT = 'spot';
export const MARKET_FUTURES = 'futures';

const listeners = new Set();

function _normalize(value) {
    return value === MARKET_FUTURES ? MARKET_FUTURES : MARKET_SPOT;
}

export function getCurrentMarket() {
    return _normalize(localStorage.getItem(KEY));
}

export function setCurrentMarket(market) {
    const safe = _normalize(market);
    const prev = localStorage.getItem(KEY);
    localStorage.setItem(KEY, safe);
    if (prev !== safe) listeners.forEach(fn => { try { fn(safe); } catch (_) {} });
}

export function subscribeToCurrentMarket(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

/** Preferência de mercado padrão (entra direto após login). null = mostrar cards. */
export function getDefaultMarket() {
    const v = localStorage.getItem(DEFAULT_KEY);
    return v === MARKET_SPOT || v === MARKET_FUTURES ? v : null;
}

export function setDefaultMarket(market) {
    if (market === MARKET_SPOT || market === MARKET_FUTURES) localStorage.setItem(DEFAULT_KEY, market);
    else localStorage.removeItem(DEFAULT_KEY);
}

/** Caminho "home" de cada mercado (spot respeita a preferência dashboard/reports). */
export function getMarketHomePath(market) {
    if (_normalize(market) === MARKET_FUTURES) return '/futures';
    return getPathHomePage();
}
